import record from "./record";

export default {
  record,
};
